import { render, staticRenderFns } from "./AdditionalFeeCategory.vue?vue&type=template&id=530ed764&"
import script from "./AdditionalFeeCategory.vue?vue&type=script&lang=js&"
export * from "./AdditionalFeeCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530ed764')) {
      api.createRecord('530ed764', component.options)
    } else {
      api.reload('530ed764', component.options)
    }
    module.hot.accept("./AdditionalFeeCategory.vue?vue&type=template&id=530ed764&", function () {
      api.rerender('530ed764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/AdditionalFeeCategory.vue"
export default component.exports